import React from 'react';
function BodyFatTable({ result }) {
  return (
    <div>
      <div>
        <table >
          <thead>
            <tr>
              <th >État </th>
              <th >Pourcent</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>Pourcentage de graisse corporelle:</td>
              <td>{result.bodyFatPercentage} %</td>
            </tr>
            <tr >
              <td>Masse de graisse</td>
              <td>{result.fatMass} kg</td>
            </tr>
            <tr >
              <td>Masse musculaire maigre</td>
              <td>{result.leanMass} kg</td>
            </tr>
            <tr >
              <td>Classification des graisses corporelles</td>
              <td>{result.bodyFatCategory}</td>
            </tr>
            {result.idealBodyFatPercentage !== 0 && (
              <>
                <tr>
                  <td>Pourcentage idéal de graisse corporelle:</td>
                  <td>{result.idealBodyFatPercentage} %</td>
                </tr>
                <tr>
                  <td>Graisse à perdre pour atteindre le niveau idéal:</td>
                  <td>{result.bodyFatToLose} kg</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
        <br />
        <hr />
        <div>
          <table >
            <thead>
              <tr>
                <th >Classification </th>
                <th >Homme</th>
                <th >Femme </th>
              </tr>
            </thead>
            <tbody>
              <tr className={result.bodyFatCategory === 'Essential Fat' ? 'highlightedOk' : ''}>
                <td>Graisse essentielle (Essential Fat)</td>
                <td>2-5%</td>
                <td>10-13%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Athletes' ? 'highlightedOk' : ''}>
                <td>Athlètes (Athletes)</td>
                <td>6-13%</td>
                <td>14-20%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Fitness' ? 'highlightedOk' : ''}>
                <td>Forme physique (Fitness)</td>
                <td>14-17%</td>
                <td>21-24%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Acceptable' ? 'highlightedOk' : ''}>
                <td>Acceptable (Acceptable)</td>
                <td>18-24%</td>
                <td>25-31%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Obese' ? 'highlightedDanger' : ''}>
                <td>Obésité (Obese)</td>
                <td>+ 25%</td>
                <td>+ 32%</td>
              </tr>
              <tr>
                <td colSpan="3">
                  <b>Source:</b>{' '}
                  <a href="https://www.acefitness.org/resources/everyone/tools-calculators/percent-body-fat-calculator/">
                    Conseil américain de l'exercice
                  </a>
                </td>
              </tr>
              <tr>
                <td colSpan="3">
                  <b>Dernière révision:</b> 28/02/2026
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
    </div>
  );
}
export default BodyFatTable;